import React, { ReactNode, SyntheticEvent } from 'react';
import styled from 'styled-components';

import { colors } from 'theme';

import CloseIcon from 'close.svg';

import { ButtonBase } from './ButtonBase';

const StyledCloseButton = styled(ButtonBase)`
  padding: 8px 16px;
  color: ${colors.battleshipGrey};
  &:hover {
    color: ${colors.waterBlue};
    &:disabled {
      &:hover {
        color: ${colors.battleshipGrey};
      }
    }
  }
  background-color: transparent;
  border-radius: 0;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const CloseButton = ({
  width = '13',
  height = '12',
  ...props
}: {
  children?: ReactNode;
  'data-qa-id'?: string;
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void;
  onMouseDown?: (event: SyntheticEvent<HTMLButtonElement>) => void;
  width?: string;
  height?: string;
}) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <StyledCloseButton p={0} {...props}>
    <CloseIcon width={width} height={height} />
  </StyledCloseButton>
);

export const ClearButton = styled(CloseButton)`
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  right: 17px;
  padding-left: 3px;
  padding-right: 3px;
`;
